export default __webpack_public_path__ + "static/media/before-footer-img2.554f5ba8.png";